module.exports = __webpack_public_path__ + "static/media/antigua-accommodation-18.4a3cd6de.jpg";